// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Vuex from 'vuex'
import Vuetify from 'vuetify'

import App from './App'
import router from './router'
// import firebase from 'firebase'
import VueFirestore from 'vue-firestore'

import VueAnalytics from 'vue-analytics'

import store from './store'

import titleMixin from './helpers/title'

import { FBApp, FBUIApp } from './helpers/firebaseConfig'

FBApp.auth().onAuthStateChanged(user => store.commit('SET_USER', user))
store.commit('SET_FB_APP', FBApp)
store.commit('SET_FB_UI_APP', FBUIApp)

Vue.use(Vuetify)
Vue.config.productionTip = false

Vue.mixin(titleMixin)

// firestore
Vue.use(VueFirestore)

Vue.use(VueAnalytics, {
  id: 'UA-112643607-1',
  router
})

const firestore = FBApp.firestore()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  firestore () {
    return {
      teams: firestore.collection('teams')
    }
  }
})

Vue.filter('dateformat', function (value) {
  if (!value) return ''

  var hour = value.getHours()
  var minute = value.getMinutes()
  var dayOfWeek = value.getDay()
  var dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek]

  value = value.getFullYear() + '年' + (value.getMonth() + 1) + '月' + value.getDate() + '日（' + dayOfWeekStr + '）' + hour + ':' + ('0' + minute).slice(-2)
  return value
})



// WEBPACK FOOTER //
// ./src/main.js